import { Component, OnInit } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { Subject, takeUntil } from 'rxjs';
import { SearchAdministratorModel } from 'src/app/admin-panel/models/system-profiles/search-administrator.model';
import { UserProfileModel } from 'src/app/admin-panel/models/system-profiles/user-profile.model';
import { AdministratorService } from 'src/app/admin-panel/services/system-profiles/administrator-service';
import { AddOrEditAdministratorComponent } from './add-or-edit-administrator/add-or-edit-administrator.component';
import { DeleteAdministratorComponent } from './delete-administrator/delete-administrator.component';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-administrator',
  templateUrl: './administrator.component.html',
  styleUrls: ['./administrator.component.scss']
})
export class AdministratorComponent implements OnInit {

  //#region Fields
  public unsubscribe: Subject<void> = new Subject<void>();
  public searchAdministratorModel: SearchAdministratorModel = new SearchAdministratorModel();
  public userProfileList: Array<UserProfileModel>;
  public totalPages: number;
  public totalRecords: number;
  public imagePath: string = './assets/images/icons/profile-picture-placeholder.png'
  //#endregion
  //#region Constructor
  constructor(
    public dialogService: DialogService,
    public administratorService: AdministratorService,
    private messageService: MessageService
  ) {


    this.userProfileList = new Array<UserProfileModel>();

  }

  ngOnInit(): void {
    this.getAllAdmins(this.searchAdministratorModel)
  }
  //#endregion

  //#region Public Methods

  getAllAdmins(searchModel: SearchAdministratorModel) {
    this.administratorService.getAllAdmins(searchModel)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.totalPages = response.totalPages;
          this.totalRecords = response.totalRecords;
          if (this.searchAdministratorModel.pageNumber > 1) {
            this.userProfileList = this.userProfileList.concat(response.data)
          }
          else {
            this.userProfileList = response.data;
          }         
        },
        error: errorResponse => {         
        }
      });

  };
  searhAdministrators(searchModel: SearchAdministratorModel) {
    searchModel.pageNumber = 1;
    this.getAllAdmins(searchModel)
  }
  clearSearch() {
    this.searchAdministratorModel = new SearchAdministratorModel();
    this.getAllAdmins(this.searchAdministratorModel);
  }
  loadMoreUser() {
    this.searchAdministratorModel.pageNumber = this.searchAdministratorModel.pageNumber + 1;
    this.getAllAdmins(this.searchAdministratorModel);
  }
  addNewAdministrator() {
    const ref = this.dialogService.open(AddOrEditAdministratorComponent, {
      header: 'Add New Administrator',
      width: '760px',
      styleClass: 'ml_200, mb_15'
    });
    ref.onClose.subscribe((item: any) => {
      if (item) {
        this.searchAdministratorModel.pageNumber = 1;
        this.getAllAdmins(this.searchAdministratorModel)
        this.messageService.add({severity:'success', summary:'User was succesful added!',life:3000});
      }
    });
  }
  editAdministrator(userId: string) {
    const ref = this.dialogService.open(AddOrEditAdministratorComponent, {
      data: {
        id: userId
      },
      header: 'Edit Administrator',
      width: '760px',
      styleClass: 'ml_200, mb_15'
    });
    ref.onClose.subscribe((item: any) => {
      if (item) {
        this.searchAdministratorModel.pageNumber = 1;
        this.getAllAdmins(this.searchAdministratorModel)
        this.messageService.add({severity:'success', summary:'User was succesful updated!',life:3000});
      }
    });
  }
  deleteAdministrator(userId: string) {
    const ref = this.dialogService.open(DeleteAdministratorComponent, {
      data: {
        id: userId
      },
      header: 'Delete Administrator',
      width: '450px',
      styleClass: 'ml_200 , mb_15'
    });
    ref.onClose.subscribe((item: any) => {
      if (item) {
        this.searchAdministratorModel.pageNumber = 1;
        this.getAllAdmins(this.searchAdministratorModel)
        this.messageService.add({severity:'success', summary:'User was succesful deleted!',life:3000});
      }
    });
  }
  //#endregion
  //#Private Methods
  //#endregion
}
